export const LOCALE_DEFAULT = "en";
